import axios from 'axios'
import type { JobCompanyForm } from '../../../schema/job'
import { getApiUrl, PERFORMANCE_BASED_JOB_API_URL } from '../../util/api/api'

const submitJobCompanyInfo = ({ data, jobId }: { data: JobCompanyForm; jobId: string }) =>
  axios.post<void>(getApiUrl(`${PERFORMANCE_BASED_JOB_API_URL}/company/${jobId}`), data, {
    withCredentials: true,
  })

export default submitJobCompanyInfo
